module.exports = __webpack_public_path__ + "static/img/Bachelor_010700.d63ea79.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010700.jpg
// module id = 226
// module chunks = 0